import { gql } from "apollo-angular";

export const deleteMinimumWageMutation = gql`
mutation deleteMinimumWage($id: UUID!, $tenantId: UUID!){
  deleteMinimumWage(id: $id, tenantId: $tenantId){
      data{
          deleted
      }
      errors{
          message
          extensions{
              errorCode
              propertyName
              attemptedValue
              severity
          }
      }
  }
}
`;